import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { createPermissionGroup, resetStatus } from "../redux/usersSagas";
import { useError } from "../hooks/useError";
import { MainModal } from "../../../../components/modal/MainModal";
import { Input } from "../../../../components/form/Input/Input";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import { ErrorList } from "../../../../components/ErrorList";
import { showToast } from "../../../../utils/showToast";

export const CreateCustomPermissionGroup = ({ isOpen, onClose, selected: { id } }) => {
  const dispatch = useDispatch();

  const [roleName, setRoleName] = useState("");

  const { errors, status } = useError(() => {
    showToast("Role was created");
    onClose();
    dispatch(resetStatus());
  });

  const onSave = async () => {
    dispatch(createPermissionGroup({ id, name: roleName }));
  };

  return (
    <>
      <MainModal
        isOpen={isOpen}
        onClose={onClose}
        parentSelector=".users"
        headerText="Save This Permission Group"
        headerCloseHandler={onClose}
        bodyClassName="main-popup-body"
        primaryButtonText="Save"
        primaryButtonDisabled={!roleName && status !== "pending"}
        primaryBtnHandler={onSave}
        secondaryBtnText="Cancel"
        secondaryBtnHandler={onClose}
        height="auto"
        width={600}
      >
        <p>
          You can save this permission group for future use and you will be able to use these
          permissions for any new users added to the system.
        </p>
        <Input
          value={roleName}
          onChange={setRoleName}
          label="Group Name (for example, manager, front desk, headquarters"
          htmlFor="roleName"
        />
        {status === "pending" && <LoadingAnimation uiLoader />}

        <ErrorList errors={errors} />
      </MainModal>
    </>
  );
};
